const api = {};

api.if = (predicate, generator) => {
  return !!predicate ? generator() : '';
};

api.cls = (obj) => {
  return Object.keys(obj).filter(key => !!obj[key]).join(' ');
};

module.exports = api;
